import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const SettingsHome = lazy(() => import("./settings-home"));
const AccountPage = lazy(() => import("./account"));
const TemplatesComponent = lazy(() => import("./templates"));
const Permissions = lazy(() => import("./permissions"));
const ConfigurationFieldsPage = lazy(() => import("./configurationFields"));
const Organisations = lazy(() => import("./organisations"));
const Users = lazy(() => import("./users"));
const CommunicationTemplates = lazy(() => import("./communicationTemplates"));
const ErrorPage = lazy(() => import("@root/error"));

export const settingsRoutes: RouteObject[] = [
  {
    path: "/v2/settings",
    element: <SettingsHome />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/settings/user/:id",
    element: <AccountPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/settings/modeles",
    element: <TemplatesComponent />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/settings/modeles/:id",
    element: <TemplatesComponent />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/settings/permissions",
    element: <Permissions />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/settings/custom-fields",
    element: <ConfigurationFieldsPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/settings/organisations",
    element: <Organisations />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/settings/users",
    element: <Users />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/settings/templates",
    element: <CommunicationTemplates />,
    errorElement: <ErrorPage />,
  },
];
